<div class="wo-no-data-cell" [style.height]="height">
  <div class="wo-no-data-cell-title">
    <ng-template [ngTemplateOutlet]="title ?? viewTitle?.template ?? null"/>
  </div>
  <div class="wo-no-data-cell-subtitle">
    <ng-template [ngTemplateOutlet]="subtitle ?? viewSubtitle?.template ?? null"/>
  </div>
  <div>
    <ng-content/>
  </div>
</div>
